var jquery = require('jquery');
window.$ = window.jQuery = jquery;

(function() {
  var hash = window.location.hash;
  var exclusions = ['/events'];

  function repositionContentForMobile(cb) {
    $('.accordion-tabs').each(function(i) {
      var $root = $(this);
      var $content = $root.find('.target-group .accordion-tab-content');

      $('.accordion-tab').removeClass('active').attr('aria-expanded', false);
      $content.removeClass('active');
      $content.removeAttr('style');

      $content.each(function(i) {
        var $target = $root.find('div[data-target="' + $(this).attr('id') + '"]');
        $(this).insertAfter($target);
      });

      $('.accordion-tab').addClass('mobile');
    })

    if (cb) { cb(); }
  }

  if ($(window).innerWidth() < 900) {
    $('.accordion-tab').addClass('mobile').removeClass('active').attr('aria-expanded', false);
    repositionContentForMobile(handleHash);
  }
  else {
    handleHash();
  }

  var query = window.matchMedia('(min-width: 900px)');

  query.addListener(function() {
    var $roots = $('.accordion-tabs');

    if (query.matches) {

      // Desktop
      $roots.each(function(i) {
        var $root = $(this);
        var $content = $root.find('.select-group .accordion-tab-content');

        $root.find('.accordion-tab').removeClass('active').attr('aria-expanded', false);
        $root.find('.accordion-tab').first().addClass('active').attr('aria-expanded', true);
        $content.first().addClass('active');
        $content.removeAttr('style');

        $root.find('.target-group').append($content);

        $('.accordion-tab').removeClass('mobile');
      })
    }
    else {
      // Mobile
      repositionContentForMobile();
    }
  })

  $('.select-group').on('click', '.accordion-tab', function() {
    if ($(this).hasClass('mobile')) {
      var $parent = $(this).parent();
      var target = $(this).data('target').split("'").join('');
      var $target = $parent.find('#' + target);

      $(this).toggleClass('active');

      $target.slideToggle('fast', function() {
        $target.toggleClass('accordion-open')
      })
    }
    else {
      var $parent = $(this).parents('.accordion-tabs');

      // Content
      var $targetGroup = $(this).parents('.accordion-tabs').find('.target-group');
      $targetGroup.find('.accordion-tab-content').removeClass('active');

      var target = $(this).data('target').split("'").join('');
      var $target = $targetGroup.find('#' + target);
      $target.addClass('active');

      // Tab / Accordion Header
      $parent.find('.accordion-tab').removeClass('active').attr('aria-expanded', false);
      $(this).addClass('active').attr('aria-expanded', true);
    }

    updateHash($(this).data('target'));
  })

  // Keyboard Navigation
  $('.select-group').on('keydown', '.accordion-tab', function(e) {
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      if ($(this).next('.accordion-tab').length === 0) {
        $(this).parents('.accordion-tabs').find('.accordion-tab').first().click().focus();
      }
      $(this).next().click().focus();
    }

    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      if ($(this).prev('.accordion-tab').length === 0) {
        $(this).parents('.accordion-tabs').find('.accordion-tab').last().click().focus();
      } else {
        $(this).prev().click().focus();
      }
    }

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).click();
    }
  })

  function handleHash() {
    if (hash !== '' && !exclusions.includes(window.location.pathname)) {
      hash = hash[hash.length-1] === '/' ? hash.substring(1,hash.length-1) : hash.substring(1);
      var $target = $('#' + hash).first();
      var $parent = $target.parents('.accordion-tabs');

      if ($target.length) {
        // Content
        $parent.find('.accordion-tab-content').removeClass('active').removeAttr('style');
        
        $target.slideToggle('fast', function() {
          $target.addClass('active');
          $target.removeAttr('style');
        });

        // Toggles
        $parent.find('.accordion-tab').removeClass('active');

        $toggle = $('div[data-target="' + hash + '"]').first();
        $toggle.addClass('active');

        scrollToTarget($target);
      }
    }
  }

  function scrollToTarget($target) {
    jQuery('html, body').animate({
      scrollTop: ($target.offset().top - 300)
    }, 500);
  }

  function updateHash($target) {
    if (window.history.pushState) {
      window.history.replaceState(null, null, '#' + $target);
    }
    else {
      window.location.hash = '#' + $target;
    }
  }

})();